import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Suggerimento } from 'src/app/models/suggerimento';
import { SuggerimentoService } from 'src/app/services/suggerimento.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditSuggerimentoComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'suggerimenti',
  templateUrl: './suggerimenti.component.html',
  styleUrls: ['./suggerimenti.component.scss']
})
export class SuggerimentiComponent implements OnInit {


  headingText: string = 'Suggerimenti';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Titolo',
        internalName: 'titolo',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Testo',
        internalName: 'testo',
        displayFunction: (model) => model['testo'].substring(0, 25),
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Campo',
        internalName: 'campo',
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Ordinale',
        internalName: 'ordinale',
      }
    ),

  ];
  constructor(public suggerimentoService: SuggerimentoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<SuggerimentiComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona uno suggerimento';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      titolo: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (suggerimento: Suggerimento) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il suggerimento ${suggerimento.humanIdentifier}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.suggerimentoService.delete(suggerimento);
          this.toast.success('Suggerimento eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione suggerimento fallita.", "Errore!");
    }
  }



  editFunction = async (suggerimento: Suggerimento) => {
    try {
      let dialogRef = this.dialog.open(EditSuggerimentoComponent, { data: suggerimento });
      dialogRef.afterClosed().subscribe(async (data: Suggerimento) => {
        if (data) {

          Object.assign(suggerimento, data);

          await this.suggerimentoService.edit(suggerimento);

          this.toast.success('Suggerimento modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica suggerimento fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditSuggerimentoComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(suggerimento?: Suggerimento) {
    if (suggerimento) {
      try {
        await this.suggerimentoService.create(suggerimento)
        this.toast.success('Suggerimento creato!')
      }
      catch (e) {
        this.toast.error('Creazione suggerimento fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
